// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__7ZWW3","clip-spin":"Loader_clip-spin__1cl4E"};